import { useState, useRef, useLayoutEffect } from "react";
import { createPortal } from "react-dom";

interface ICoverageBadgeProps {
  isCovered: boolean;
  notCoveredReason?: string;
}

const COVERED_TOOLTIP = "Este item está coberto pelo plano de manutenção.";
const NOT_COVERED_TOOLTIP = "Este item não está coberto pelo plano de manutenção.";
const TOOLTIP_GAP = 8;

const CoverageBadge = (props: ICoverageBadgeProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState<{ top: number; left: number } | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const baseClasses = "flex px-5 py-2 px-5 items-center justify-center text-[10px] font-medium text-white whitespace-nowrap uppercase leading-none cursor-default";
  const tooltipText = props.isCovered
    ? COVERED_TOOLTIP
    : (props.notCoveredReason?.trim() || NOT_COVERED_TOOLTIP);

  useLayoutEffect(() => {
    if (!showTooltip || !wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    setTooltipStyle({
      top: rect.top + rect.height / 2,
      left: rect.right + TOOLTIP_GAP,
    });
  }, [showTooltip]);

  const badge = props.isCovered ? (
    <span className={`${baseClasses} bg-green-600`}>
      Coberto pelo plano
    </span>
  ) : (
    <span className={`${baseClasses} bg-red-600`}>
      Sem cobertura
    </span>
  );

  const tooltipEl =
    showTooltip &&
    tooltipStyle &&
    createPortal(
      <div
        className="coverage-badge-tooltip fixed z-[99999] px-3 py-2 rounded bg-[#000000] text-[#ffffff] text-size-12 text-center max-w-[220px] shadow-lg whitespace-normal -translate-y-1/2"
        style={{ top: tooltipStyle.top, left: tooltipStyle.left }}
        role="tooltip"
      >
        {tooltipText}
        <span
          className="absolute right-full top-1/2 -translate-y-1/2 border-[6px] border-transparent border-r-black"
          style={{ marginRight: "-1px" }}
        />
      </div>,
      document.body
    );

  return (
    <div
      ref={wrapperRef}
      className="relative inline-flex w-full justify-start"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {badge}
      {tooltipEl}
    </div>
  );
};

export default CoverageBadge;
